type ProductCreatedRange = {
  startDate: string;
  endDate: string;
};

function getProductCreatedFilters(
  productCreatedRange: ProductCreatedRange | null | undefined,
): string[] {
  if (!productCreatedRange) return [];

  const filters: string[] = [];

  if (productCreatedRange.startDate) {
    const startTimestamp = Math.floor(
      new Date(productCreatedRange.startDate).getTime() / 1000,
    );
    filters.push(`productCreated>=${startTimestamp}`);
  }

  if (productCreatedRange.endDate) {
    const endTimestamp = Math.floor(
      new Date(productCreatedRange.endDate).getTime() / 1000,
    );
    filters.push(`productCreated<=${endTimestamp}`);
  }

  return filters;
}

export default getProductCreatedFilters;
